export const layoutWidth = 'calc(100% - 48px)';
export const layoutMinWidth = '1000px';
export const layoutMaxWidth = 'calc(1920px - 48px)';
export const sidebarBackdropLeftPosition = 'calc(50vw - 739px)';
export const mobileLayoutWidth = 'calc(100% - 28px)';
export const mobileLayoutMinWidth = '292px';
export const mobileViewPortMinWidth = '320px';
